import DateInput from "../DateInput";
import { Label } from "../ui/label";

export const LottoDateFields = ({ form, setForm }) => (
  <section className="space-y-3" data-testid="lotto-date-fields">
    <div className="grid grid-cols-2 gap-2 sm:gap-3" data-testid="lotto-primary-date-row">
      <div className="min-w-0 space-y-1.5">
        <Label className="text-xs leading-tight" data-testid="lotto-apertura-label">Data apertura</Label>
        <DateInput value={form.data_apertura} onChange={v => setForm(prev => ({ ...prev, data_apertura: v }))} testId="lotto-apertura" />
      </div>
      <div className="min-w-0 space-y-1.5">
        <Label className="text-xs leading-tight" data-testid="lotto-scadenza-chiuso-label">Scadenza lotto</Label>
        <DateInput value={form.data_scadenza} onChange={v => setForm(prev => ({ ...prev, data_scadenza: v }))} testId="lotto-scadenza-chiuso" />
      </div>
    </div>
  </section>
);